import { useAuth } from '@turiya/login-component';
import { useCallback, useEffect, useState } from 'react';
import {
    getFirstNonSupportClients,
    getNonSupportClients,
    isExternalUser as isExternalUserExtractor,
    isSupportUser as isSupportUserExtractor,
} from './utils';

interface UseClientId {
    clientId: string | undefined;
    clientIds: string[];
    isSupportUser: boolean;
    isExternalUser: boolean | undefined;
    isClientInitialized: boolean;
}

export const useClientId = (): UseClientId => {
    const [clientId, setClientId] = useState<string>();
    const [clientIds, setClientIds] = useState<string[]>([]);
    const [isSupportUser, setIsSupportUser] = useState<boolean>(false);
    const [isExternalUser, setIsExternalUser] = useState<boolean | undefined>(undefined);
    const [isClientInitialized, setIsClientInitialized] = useState<boolean>(false);

    const { getCurrentToken } = useAuth();
    const currentToken = getCurrentToken() ?? '';

    const initializeClient = useCallback(() => {
        setClientId(getFirstNonSupportClients(currentToken));
        setClientIds(getNonSupportClients(currentToken));
        setIsSupportUser(isSupportUserExtractor(currentToken));
        setIsExternalUser(isExternalUserExtractor(currentToken));
        setIsClientInitialized(true);
    }, [currentToken]);

    useEffect(() => {
        initializeClient();
    }, [initializeClient]);

    return {
        clientId: clientId,
        clientIds: clientIds,
        isSupportUser: isSupportUser,
        isExternalUser: isExternalUser,
        isClientInitialized: isClientInitialized,
    };
};
